import {Address, ICompanyLeadSettings} from ".";

export class CompanyLead {
  public readonly type = "CompanyLead";
  private _settings: ICompanyLeadSettings;
  private _address: Address;

  constructor(settings: ICompanyLeadSettings, address: Address) {
    this._settings = settings;
    this._address = address;
  }

  public get settings(): ICompanyLeadSettings {
    return this._settings;
  }
  public get address(): Address {
    return this._address;
  }
}
